import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { apiError } from "@/context/AuthContext";
import { fmtDate } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ClockClockwise, Check, X } from "@phosphor-icons/react";

export default function Extensions() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const load = () => api.get("/extensions?status=pending").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const decide = async (e, decision) => {
    try { await api.post(`/tasks/${e.task_id}/extension/${e.id}/decision`, { decision }); toast.success(`Extension ${decision}`); load(); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };

  return (
    <div className="p-6 lg:p-8 max-w-[1200px] animate-fade-in">
      <div className="text-[10px] uppercase tracking-[0.2em] text-emerald-600 font-bold mb-1">Work</div>
      <h1 className="font-heading text-3xl font-black tracking-tight text-zinc-50 mb-6">Extension Requests</h1>
      {items.length === 0 ? (
        <div className="border border-zinc-800 bg-zinc-900/30 p-12 text-center text-zinc-500">
          <ClockClockwise size={40} className="mx-auto mb-3 text-zinc-700" /> No pending extension requests.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((e) => (
            <div key={e.id} className="border border-zinc-800 bg-zinc-900/30 p-4 flex items-center gap-4 flex-wrap" data-testid={`ext-${e.id}`}>
              <div className="flex-1 min-w-0">
                <button onClick={() => navigate(`/tasks/${e.task_id}`)} className="text-sm text-zinc-100 hover:text-emerald-400 transition-colors font-medium">
                  <span className="font-mono text-xs text-emerald-600 mr-2">{e.task?.ref_code || e.task?.customer_name}</span>{e.task?.title}
                </button>
                <div className="text-xs text-zinc-500 mt-1">
                  {e.requested_by_name} requests new due <span className="text-zinc-300">{fmtDate(e.requested_due)}</span>
                </div>
                <p className="text-xs text-zinc-400 mt-1">Reason: {e.reason}</p>
              </div>
              <div className="flex gap-2">
                <Button size="sm" onClick={() => decide(e, "approve")} className="bg-emerald-600 hover:bg-emerald-700 rounded-sm gap-1" data-testid={`ext-approve-${e.id}`}><Check size={14} weight="bold" /> Approve</Button>
                <Button size="sm" variant="outline" onClick={() => decide(e, "reject")} className="border-red-500/30 text-red-400 bg-red-500/5 rounded-sm gap-1" data-testid={`ext-reject-${e.id}`}><X size={14} /> Reject</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
